export default "__VITE_PUBLIC_ASSET__c769afda__"